import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState = {
    successMessage: {
        message: null,
        type: null,
        show: false,
        toggle: function() {
           this.show= !this.show;
        }
    
    },
}

export const appSlice = createSlice({
    name: 'appStates',
    initialState: initialState,
    reducers: {
        setSuccessMessage: (state, { payload }) => {
            state.successMessage = payload;
            state.successMessage.show = true;
        },
        clearSuccessMessage: (state) => {
            state.successMessage.message = null;
            state.successMessage.type = null;
            state.successMessage.show = false;
        },
        toogleSuccessMessage: (state, { payload }) => {
            state.successMessage.toggle();
        }
    }
})
export const { setSuccessMessage,toogleSuccessMessage, clearSuccessMessage } = appSlice.actions


export default appSlice.reducer
export const appSelector = state => state.appStates